<template>
  <div ref="messageText" @click.prevent="toggleMessageHeight" class="flex overflow-hidden pr-8 relative whitespace-normal items-start message-wrap" :class="{ 'expanded' : expanded, 'expandable' : canBeExpanded }">
    <font-awesome-icon v-if="data.media" :icon="['far', 'image']" class="text-base mr-2 text-gray-600"></font-awesome-icon>
    <span>{{message}}</span>
    <button class="absolute right-0 expand-icon" v-if="canBeExpanded">
        <font-awesome-icon v-if="!expanded" :icon="['far', 'plus']" class="text-base mr-2 relative"></font-awesome-icon>
        <font-awesome-icon v-else :icon="['far', 'minus']" class="text-base mr-2 relative"></font-awesome-icon>
    </button>
  </div>
</template>

<script>
export default {
  name: "MessageTableMessage",
  props: {
    meta: {
      type: Object,
      default: () => {}
    },
    name: {
      type: String,
      default: ""
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: { },
  data() {
    return {
      expanded: false,
      canBeExpanded: false,
    };
  },
  computed: {
    message() {
      if (this.data.parsed_message) return this.data.parsed_message;
      if (this.data.unparsed_message) return this.data.unparsed_message;
      if (this.data.message) return this.data.message;
    }
  },
  mounted() {
    const divHeight = this.$refs.messageText.offsetHeight;
    const textHeight = this.$refs.messageText.getElementsByTagName('span')[0].scrollHeight;

    if ( textHeight > divHeight ) {
      this.canBeExpanded = true;
    }
  },
  methods: {
    toggleMessageHeight(event) {
        if (!this.canBeExpanded) return;
        //this is done so non-expandable messages can still be clicked (to view the message details), and only expandable
        //messages will toggle the expanded state without navigating to the view state
        event.stopPropagation();
        this.expanded = !this.expanded;
    }
  },
};
</script>

<style scoped>

.message-wrap {
  height: 24px;
  word-break: break-all;

}

.message-wrap.expandable {
  cursor: pointer;
}

.message-wrap span {
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.message-wrap.expanded {
  height: auto;
}

.message-wrap.expanded span {
  display: block;
}

.message-wrap button {
  opacity: 0;
  transition: opacity 0.2s ease;
  z-index: 2;
}

.message-wrap:hover button,
.message-wrap:focus-within button {
  opacity: 1;
}

.message-wrap.expandable::after {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 2rem;
  z-index: 1;
}

</style>
